import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class Account extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            type: props.Type,
            data: null,
            loading: true,
            version: this.uuidv4()
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/account/get", {
            id: this.getCurrentFormId(),
            type: this.state.type,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.parentCode)) this.state.data.record.parentCode = 0;
        if (this.isBlank(this.state.data.record.objectId)) this.state.data.record.objectId = 0;
        this.httpPost("api/v1/account/save", {
            id: this.getCurrentFormId(),
            organizationId: this.state.data.global.company.id,
            type: this.state.data.record.type,
            title: this.state.data.record.title,
            code: this.state.data.record.code,
            parentCode: parseInt(this.state.data.record.parentCode),
            objectId: parseInt(this.state.data.record.objectId),
            type: this.state.data.record.type,
            accountGroupQuiddity: this.state.data.record.accountGroupQuiddity,
            accountMoeinQuiddity: this.state.data.record.accountMoeinQuiddity,
            detailed: this.state.data.record.detailed,
            follow: this.state.data.record.follow,
            counting: this.state.data.record.counting,
            currency: this.state.data.record.currency,
            solutionMostSelect: this.state.data.record.solutionMostSelect,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    changeType(e) {
        this.state.data.record.type = e;
        this.renewCode();
    }
    setParentCode(e) {
        this.state.data.record.parentCode = parseInt(e.target.value);
        this.renewCode();
    }
    renewCode() {
        this.httpPost("api/v1/account/lastcode", {
            type: this.state.data.record.type,
            parentCode: this.state.data.record.parentCode
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data.record.code = data.code;
                }
                else {
                    this.showErorrMessage(data.message);
                }

                this.renewFullCode();

                this.setState({
                    loading: false,
                    version: this.uuidv4()
                });
            });
    }
    setCode(e) {
        this.state.data.record.code = e.target.value;
        this.renewFullCode();
        this.setState({ data: this.state.data });
    }
    renewFullCode() {
        if (this.isBlank(this.state.data.record.parentCode))
            this.state.data.record.fullCode = parseInt(this.state.data.record.code.toString());
        else
            this.state.data.record.fullCode = parseInt(this.state.data.record.parentCode.toString() + this.state.data.record.code.toString());
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }}></div>
            <div className="modal-dialog ui-draggable" style={{ "min-width": "70%" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="modal-header modal-header-info">
                            <button type="button" className="hand close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات حساب" : "افزودن حساب جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <label className="form-label">سطح</label>
                                        <div className="form-control-wrap">
                                            <select disabled={this.state.data.record.id !== this.defaultGuid()} className="form-control" defaultValue={this.state.data.record.type} onChange={e => this.changeType(parseInt(e.target.value))}>
                                                <option value="1">گروه</option>
                                                <option value="2">کل</option>
                                                <option value="3">معین</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {this.state.data.record.type == 2 && <div className="col-lg-4">
                                    <div className="form-group">
                                        <label className="form-label">سرفصل</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" defaultValue={this.state.data.record.parentCode} onChange={e => this.setParentCode(e)}>
                                                <option value="0">انتخاب کنید ...</option>
                                                {this.state.data.groups.map(g => <option value={g.fullCode}>{g.fullCode} - {g.title}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type == 3 && <div className="col-lg-4">
                                    <div className="form-group">
                                        <label className="form-label">سرفصل</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" defaultValue={this.state.data.record.parentCode} onChange={e => this.setParentCode(e)}>
                                                <option value="0">انتخاب کنید ...</option>
                                                {this.state.data.kols.map(g => <option value={g.fullCode}>{g.fullCode} - {g.title}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                <div className="col-lg-2" key={this.state.version}>
                                    <div className="form-group">
                                        <label className="form-label">کد <b>({this.state.data.record.type === 1 ? "1" : this.state.data.record.type === 2 ? "2" : this.state.data.record.type === 3 ? "5" : ""}رقم)</b></label>
                                        <div className="form-control-wrap">
                                            <input className="form-control text-center" type="text" defaultValue={this.state.data.record.code} onChange={e => this.setCode(e)} />
                                        </div>
                                    </div>
                                </div>
                                {this.state.data.record.type !== 1 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">کدکامل</label>
                                        <div className="form-control-wrap" key={this.state.data.record.fullCode}>
                                            <input className="form-control text-center" type="text" disabled defaultValue={this.state.data.record.fullCode} />
                                        </div>
                                    </div>
                                </div>}
                            </div>
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="form-group">
                                        <label className="form-label">عنوان حساب</label>
                                        <div className="form-control-wrap">
                                            <input className="form-control" type="text" defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} />
                                        </div>
                                    </div>
                                </div>
                                {this.state.data.record.type == 1 && <div className="col-lg-3">
                                    <div className="form-group">
                                        <label className="form-label">نوع</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" defaultValue={this.state.data.record.accountGroupQuiddity} onChange={e => this.state.data.record.accountGroupQuiddity = parseInt(e.target.value)}>
                                                <option value="1">ترازنامه ای - دارایی</option>
                                                <option value="2">ترازنامه ای - بدهی</option>
                                                <option value="3">ترازنامه ای - سرمایه</option>
                                                <option value="10">سود و زیانی - درآمد</option>
                                                <option value="11">سود و زیانی - هزینه</option>
                                                <option value="20">انتظامی</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type == 1 && <div className="col-lg-3">
                                    <div className="form-group">
                                        <label className="form-label">ماهیت</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" defaultValue={this.state.data.record.accountMoeinQuiddity} onChange={e => this.state.data.record.accountMoeinQuiddity = parseInt(e.target.value)}>
                                                <option value="0">مهم نیست</option>
                                                <option value="1">بدهکار</option>
                                                <option value="2">بستانکار</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type == 3 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">تفصیل پذیری</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" defaultValue={this.state.data.record.detailed ? 1 : 0} onChange={e => this.state.data.record.detailed = (e.target.value == "1" ? true : false)}>
                                                <option value="0">ندارد</option>
                                                <option value="1">دارد</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type == 3 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">ویژگی پیگیری</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" defaultValue={this.state.data.record.follow ? 1 : 0} onChange={e => this.state.data.record.follow = (e.target.value == "1" ? true : false)}>
                                                <option value="0">ندارد</option>
                                                <option value="1">دارد</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type == 3 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">ویژگی تعدادی</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" defaultValue={this.state.data.record.counting ? 1 : 0} onChange={e => this.state.data.record.counting = (e.target.value == "1" ? true : false)}>
                                                <option value="0">ندارد</option>
                                                <option value="1">دارد</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.data.record.type == 3 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">ویژگی ارزی</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" defaultValue={this.state.data.record.currency ? 1 : 0} onChange={e => this.state.data.record.currency = (e.target.value == "1" ? true : false)}>
                                                <option value="0">ندارد</option>
                                                <option value="1">دارد</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}

                                {this.state.data.record.type == 3 && <div className="col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label">تعیین پروژه</label>
                                        <div className="form-control-wrap">
                                            <select className="form-control" defaultValue={this.state.data.record.solutionMostSelect ? 1 : 0} onChange={e => this.state.data.record.solutionMostSelect = (e.target.value == "1" ? true : false)}>
                                                <option value="0">ندارد</option>
                                                <option value="1">دارد</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}                               

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary hand" onClick={e => this.closeMe()}>انصراف</button>
                            <a name="person_forma_modal_create" onClick={e => this.save(e)} className="btn btn-success">ذخیره</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent(),
            ];

        return contents;
    }
}